import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

export const getSpecialServices = async (dateFilters) => {
    try {
        const start = dateFilters.start.value.toISOString().split('T')[0];
        const end = dateFilters.end.value.toISOString().split('T')[0];
        const res = await api.get(`${urlApi}/operaciones/specialServices?start=${start}&end=${end}`);
        return res.data;
    } catch (error) {
        console.error('Error getSpecialServices:', error);
        throw error;
    }
};

export const getDrivers = async () => {
    try {
        const res = await api.get(`${urlApi}/operaciones/getDrivers`);
        return res.data;
    } catch (error) {
        console.error('Error getDrivers:', error);
        throw error;
    }
};

export const getUnits = async () => {
    try {
        const res = await api.get(`${urlApi}/operaciones/getUnits`);
        return res.data;
    } catch (error) {
        console.error('Error getUnits:', error);
        throw error;
    }
};

export const getAllies = async () => {
    try {
        const res = await api.get(`${urlApi}/operaciones/getAllies`);
        return res.data;
    } catch (error) {
        console.error('Error getAllies:', error);
        throw error;
    }
};

export const updateService = async (data) => {
    try {
        const res = await api.put(`${urlApi}/operaciones/updateService`, data);
        console.log(res.data);
    } catch (error) {
        console.error('Error updateService:', error);
        throw error;
    }
};

export const sendUnitAssignedNotification = async (data) => {
    try {
        const res = await api.put(`${urlApi}/operaciones/sendOperatorNotification`, data);
        return res.data;
    } catch (error) {
        console.error('Error sendUnitAssignedNotification:', error);
        throw error;
    }
};

export const getLocator = async (id) => {
    try {
        const res = await api.get(`${urlApi}/operaciones/locator/${id}`);
        return res.data;
    } catch (error) {
        console.error('Error getLocator:', error);
        throw error;
    }
};